// Copyright (c) 2018 Deere & Company

import React, {PropTypes} from 'react';
import PartReturn from '@deere/cps-it.warranty-model-factory/lib/part-return';
import SmartFormLink from '../../../shared/components/smart-form-link/smart-form-link';

const RequestDetailsHeader = props =>
    <header className='request-details-header'>
        <h2>
            {props.partReturn.requestType.value} {props.partReturn.stripLeadingZerosForRgaNumber()}
        </h2>
        <SmartFormLink
            displayText='PRINT_TO_PDF'
            formName='RGA'
            icon={'PDF'}
            objectId={props.partReturn.rgaNumber}
            showAsButton={true}
            showButtonIcon={true}
            translate={true}
        />
    </header>;

RequestDetailsHeader.displayName = 'RequestDetailsHeader';
RequestDetailsHeader.propTypes = {
    language: PropTypes.string.isRequired,
    partReturn: PropTypes.instanceOf(PartReturn).isRequired
};

export default RequestDetailsHeader;



// WEBPACK FOOTER //
// ./src/part-requests/request-details/components/request-details-header.js